import { FRONTEGG_USER_KEY } from '@ww/login-ui-components/lib/utils/oauth';
import { PREV_URL_KEY, isServerAuthType } from './search-params';

function requestedFronteggLogin(searchParams: URLSearchParams): boolean {
  return searchParams.get(FRONTEGG_USER_KEY) === 'true';
}

function rememberedFronteggUser(): boolean {
  return localStorage.getItem(FRONTEGG_USER_KEY) === 'true';
}

export function declinedFronteggLogin(searchParams: URLSearchParams): boolean {
  return searchParams.get(FRONTEGG_USER_KEY) === 'false';
}

export function shouldStartFronteggLogin(searchParams: URLSearchParams): boolean {
  if (!isServerAuthType(searchParams) || declinedFronteggLogin(searchParams)) {
    return false;
  }

  if (requestedFronteggLogin(searchParams)) {
    return true;
  }

  return rememberedFronteggUser() && Boolean(searchParams.get(PREV_URL_KEY));
}

export function rememberFronteggUser(): void {
  localStorage.setItem(FRONTEGG_USER_KEY, 'true');
}

export function forgetFronteggUser(): void {
  localStorage.removeItem(FRONTEGG_USER_KEY);
}
